import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=c420f36c&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=js&"
export * from "./TheHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=c420f36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c420f36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c420f36c', component.options)
    } else {
      api.reload('c420f36c', component.options)
    }
    module.hot.accept("./TheHeader.vue?vue&type=template&id=c420f36c&scoped=true&", function () {
      api.rerender('c420f36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/TheHeader.vue"
export default component.exports